import type { SendChannel } from '@/services/notificationService'
import EmailIcon from '@/assets/chanellsIcons/EmailIcon.svg'
import SmsIcon from '@/assets/chanellsIcons/SmsIcon.svg'
import WhatsappIcon from '@/assets/chanellsIcons/WhatsappIcon.svg'

export type ChannelKind = 'whatsapp' | 'sms' | 'email' | 'other'

/** The category key decides the panel. The Gateway returns it in lower case. */
export const channelKind = (
  channel: Pick<SendChannel, 'category'>
): ChannelKind => {
  const key = channel.category.toLowerCase()
  return key === 'whatsapp' || key === 'sms' || key === 'email' ? key : 'other'
}

// Figma order, right to left: WhatsApp, SMS, e-mail. A category the design has
// no panel for comes after them.
const PANEL_ORDER: ChannelKind[] = ['whatsapp', 'sms', 'email', 'other']

export const sortForPanels = <T extends SendChannel>(channels: T[]): T[] =>
  [...channels].sort(
    (a, b) =>
      PANEL_ORDER.indexOf(channelKind(a)) - PANEL_ORDER.indexOf(channelKind(b))
  )

export const CHANNEL_ICONS: Record<ChannelKind, string | null> = {
  whatsapp: WhatsappIcon,
  sms: SmsIcon,
  email: EmailIcon,
  other: null,
}

/**
 * The hard limit of a panel, or null for none. SMS and WhatsApp stop at 200
 * characters. E-mail has no hard limit but keeps its counter.
 */
export const charLimit = (kind: ChannelKind): number | null =>
  kind === 'email' ? null : 200
